export default __webpack_public_path__ + "media/images/front/municipality_collaboration/usa/ogp-f93cc7d148792e73f571d687b2869a85.jpg";